import { render, staticRenderFns } from "./LocatieInformatieHeader.vue?vue&type=template&id=0be41060"
import script from "./LocatieInformatieHeader.vue?vue&type=script&lang=js"
export * from "./LocatieInformatieHeader.vue?vue&type=script&lang=js"
import style0 from "./LocatieInformatieHeader.vue?vue&type=style&index=0&id=0be41060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports